/*! SMALLFISH GENERATED ENTRY, DO NOT MODIFY MANUALLY */

/* ------------------- PolyfillImports START------------------- */
import '/root/template/node_modules/_@alipay_smallfish-core@2.55.2@@alipay/smallfish-core/assets/js/dynamic-public-path'
import 'core-js';
import 'regenerator-runtime/runtime';
/* -------------------- PolyfillImports END-------------------- */

/* --------------------- MainImports START--------------------- */
import '/root/template/src/styles/global-style.less';
import { renderPage } from 'smallfish:runtime';

import * as pageExports from '/root/template/src/pages/index/index';
import { IRenderOptions } from 'smallfish:types';
/* ---------------------- MainImports END---------------------- */

/* ------------------- AfterMainImports START------------------ */
import '/root/template/node_modules/_@alipay_smallfish-resource@2.55.2@@alipay/smallfish-resource/dist/inject-profile.module.min.js';
/* -------------------- AfterMainImports END------------------- */

/* ------------------------- Main START------------------------ */
renderPage(
  'app',
  [],
  {
    pageExports,
  },
);
/* -------------------------- Main END------------------------- */
